import * as React from 'react';
import { useSelector } from 'react-redux';

import { chatListSelector } from '../selectors';

interface ILeftSwipeVisibleProviderProps {
  children: React.ReactNode;
}

const LeftSwipeVisibleContext = React.createContext<boolean>(false);

export const LeftSwipeVisibleProvider: React.FC<ILeftSwipeVisibleProviderProps> = ({ children }) => {
  const [isLeftSwipeVisible, setIsLeftSwipeVisible] = React.useState(false);
  const { currentRoute } = useSelector(chatListSelector);

  // Кнопка слева не должна быть видна, пока не смахнули вправо. К сожалению, только JS...
  React.useEffect(() => {
    setTimeout(() => setIsLeftSwipeVisible(true), 0);
  }, [currentRoute]);

  return <LeftSwipeVisibleContext.Provider value={isLeftSwipeVisible}>{children}</LeftSwipeVisibleContext.Provider>;
};

export const useLeftSwipeVisible = (): boolean => {
  return React.useContext(LeftSwipeVisibleContext);
};
